import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/opt/build/repo/layouts/admin.vue").then(m => m.default || m)),
  clean: defineAsyncComponent(() => import("/opt/build/repo/layouts/clean.vue").then(m => m.default || m))
}